import { backendHost } from "./misc";

const RESPONSE_HEADERS = ["st-access-token", "st-refresh-token"];

export interface UserInfo {
  name: string
  token: string
}

export const getLoginManagers = () => {
  const setTokens = (headers) => {
    [...headers].forEach(([key, value]) => {
      if (!RESPONSE_HEADERS.includes(key)) return;
      localStorage.setItem(key, value);
    });
  };

  const isLoggedIn = async () => {
    const token = localStorage.getItem("st-refresh-token");
    if (!token) return false;

    const response = await fetch(`${backendHost}/auth/session/refresh`, {
      method: "POST",
      headers: {
        'rid': 'session',
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      setTokens(response.headers);
      return true;
    } else {
      logout();
      return false;
    }
  };

  const getUserInfo = async () => {
    const token = localStorage.getItem("st-access-token");
    const response = await fetch(`${backendHost}/api/users/me`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();

    const name = (data.firstName && data.lastName)
      ? `${data.firstName} ${data.lastName}`
      : data.email;

    return {name, token};
  };

  const getAppCode = async () => {
    const response = await fetch(`${backendHost}/api/app_codes/request`);
    const data = await response.json();
    return String(data.access_code);
  };

  const useAppCode = async (appCode: string) => {
    if (!appCode) return;

    const response = await fetch(`${backendHost}/api/app_codes/consume/${appCode}`);
    const success = response.status === 200;

    if (success) {
      setTokens(response.headers);
    }

    return success;
  };

  const logout = () => {
    RESPONSE_HEADERS.forEach(key => {
      localStorage.removeItem(key);
    });
  };

  return {
    getAppCode,
    useAppCode,
    logout,
    isLoggedIn,
    getUserInfo
  };
};


